import React from 'react';
import { graphql } from 'gatsby';
import { Helmet } from 'react-helmet';

import PageBanner from '../components/page-banner/page-banner.component';
import Blogs from '../components/blog/blogs.component';

type BlogPageProps = {
  data: GatsbyTypes.StrapiArticlesMetaQuery;
};

export const query = graphql`
  query StrapiArticlesMeta {
    allStrapiArticle(filter: { status: { eq: "published" } }) {
      edges {
        node {
          strapiId
          slug
          title
          publishedAt
          category {
            name
          }
          image {
            publicURL
            childImageSharp {
              fixed(width: 800, height: 500) {
                src
              }
            }
          }
          author {
            name
            picture {
              publicURL
              childImageSharp {
                fixed(width: 30, height: 30) {
                  src
                }
              }
            }
          }
        }
      }
    }
  }
`;

const BlogPage: React.FC<BlogPageProps> = ({ data }) => {
  return (
    <>
      <Helmet title="Blog" />
      <PageBanner
        pageTitle="Blog"
        homePageText="Home"
        homePageUrl="/"
        activePageText="Blog"
      />
      <Blogs articles={data.allStrapiArticle.edges} />
    </>
  );
};

export default BlogPage;
